import {TaskDTO} from './plyca-dtos';
import {ContractNotice} from './contract-notice-dto';

export class  OpenedTaskInfo {
	public id: string;
	public route: string;
	public taskId: string;
	public taskDTO: TaskDTO;
    public model: ViewModel;
}

export class ViewModel {
    public errors: Array<any> = [];	
}

export class ValidationError {
    id: string;
    field: string;
    message: Array<string> = [];
}